import fetch from "auth/FetchInterceptor";

const prefix = "/subscription-enrollments";

const SubscriptionEnrollmentService = {
  getEnrollments: async ({ page = 1, limit = 10, status, search } = {}) =>
    await fetch(prefix, {
      method: "GET",
      params: {
        page,
        limit,
        ...(status ? { status } : {}),
        ...(search ? { search } : {}),
      },
    }),

  getEnrollment: async (id) =>
    await fetch(`${prefix}/${id}`, {
      method: "GET",
    }),

  validateEnrollment: async (id, data = {}) =>
    await fetch(`${prefix}/${id}/validate`, {
      method: "PATCH",
      data,
    }),

  rejectEnrollment: async (id, reason) =>
    await fetch(`${prefix}/${id}/reject`, {
      method: "PATCH",
      data: { reason },
    }),

  updateReceipt: async (id, formData) =>
    await fetch(`${prefix}/${id}/receipt`, {
      method: "PATCH",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

export default SubscriptionEnrollmentService;
